<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">
    {{ "COMPARE" | translate }}
  </h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="modal.dismiss('Cross click')"
    >
  </button>
</div>

<div
  class="modal-body"
  [ngClass]="generating ? 'generating' : ''"
  [style.opacity]="generating ? '0.4' : '1'"
  >
  <div class="row">
    @if (compareArticleData.length > 3) {
      <div class="col-md-12 row">
        @for (id of selected; track id; let articleIndex = $index) {
          <div
            class="d-flex col-lg-4 col-xl-4 col-xs-12 col-sm-6 col-md-6 align-items-stretch"
            >
            <app-select-article
              [availableArticles]="objectArticleData"
              [selected]="selected"
              [id]="id"
              [index]="articleIndex"
              (articleSelected)="articleSelected($event, articleIndex)"
            ></app-select-article>
          </div>
        }
      </div>
    }
    <div class="col-md-12" id="comparedArticles">
      @if (compareArticleList.length) {
        <div
          class="articleContainer px-0 mx-0 row col-md-12 h-100"
          >
          @for (id of selected; track id; let articleIndex = $index) {
            @if (objectArticleData[id]) {
              <app-article-card
                [article]="objectArticleData[id]"
                [specs]="objectArticleData[id].allSpecs"
                [useLazyLoad]="false"
                (showArticleDetails)="showArticleDetails($event)"
                (removeFromList)="removeFromList($event)"
                class="card d-flex col-lg-4 col-xl-4 col-xs-12 col-sm-6 col-md-6 align-items-stretch"
              ></app-article-card>
            }
          }
        </div>
      }
      @if (!compareArticleList.length) {
        <div>
          {{ "NOTHING_TO_COMPARE" | translate }}
        </div>
      }
    </div>
  </div>
</div>
<div class="modal-footer" [style.opacity]="generating ? '0.4' : '1'">
  @if (selected.length) {
    <button
      class="btn btn-danger me-auto"
      [disabled]="!selected.length || generating"
      (click)="empty()"
      >
      {{ "EMPTY" | translate }}
    </button>
  }
  @if (showPdfButton) {
    <button
      class="btn btn-primary"
      [disabled]="!selected.length || generating"
      [ngClass]="!selected.length ? 'disabled' : ''"
      (click)="downloadPdf()"
      >
      PDF
    </button>
  }
  @if (!showPdfButton && loading) {
    <span
      class="spinner-border spinner-border-sm"
      role="status"
      aria-hidden="true"
    ></span>
  }
</div>
